import { Fallback } from '@amagimedia/commons/src/components/Fallback';
import { FC, lazy, Suspense } from 'react';
const STVV2LandingAppLazy = lazy(() => import('@amagimedia/stv-v2-landing'));

export const STVV2LandingApp: FC = () => {
  return (
    <Suspense fallback={<Fallback />}>
      <STVV2LandingAppLazy />
    </Suspense>
  );
};
